import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedDate } from 'react-intl';

import { TranslatedCopy } from '../../../intl/TranslatedCopy';

import { H1, H2, Link } from '../../../components';

import { FIELD_NA } from '../../constants';

export const OrderDetailsShipmentEventInfo = ({
  shipmentNumber,
  shipmentsTotal,
  cartonsTotal,
  carrierUrlAddress,
  trackingNumber,
  dateShipped,
  estimatedDeliveryDate,
  carrier,
  shippingMethod,
  shippingOrigin,
  billOfLadingNumber
}) => (
  <div className='orderDetails__shipments_info mb1-sm p5-sm pt7-sm bg-white'>
    <div className='orderDetails__shipments_infoHeader flex-container column space-between'>
      <H1>
        <TranslatedCopy id='orderstatus.shipmentCurrent' values={{ current: shipmentNumber, total: shipmentsTotal }} />
      </H1>
      <H2>
        <TranslatedCopy id='orderstatus.trackingNumber.lead' />
        {': '}
        {carrierUrlAddress &&
        carrierUrlAddress !== '' &&
        trackingNumber &&
        trackingNumber !== '' &&
        trackingNumber !== FIELD_NA ? (
          <Link to={carrierUrlAddress.replace('%TRACKINGNO%', trackingNumber)} external>
            {trackingNumber}
          </Link>
        ) : (
          <>{trackingNumber}</>
        )}
      </H2>
    </div>
    <div
      className={classnames(
        'orderDetails__shipments_infoBody',
        'body-4 flex-container column start mt5-sm p7-sm prl10-lg bg-gameday-grey-two text-color-secondary'
      )}
    >
      <ul className='pr0-sm pr10-md'>
        <li>
          <TranslatedCopy id='orderstatus.date.shipped' />
          {': '}
          {dateShipped ? <FormattedDate value={dateShipped} timeZone='utc' /> : FIELD_NA}
        </li>
        <li>
          <TranslatedCopy id='orderstatus.expectedArrival' />
          {': '}
          {estimatedDeliveryDate ? <FormattedDate value={estimatedDeliveryDate} timeZone='utc' /> : FIELD_NA}
        </li>
        <li>
          <TranslatedCopy id='orderstatus.numberOfCartons' />
          {': '}
          {cartonsTotal}
        </li>
        <li>
          <TranslatedCopy id='orderstatus.carrier' />
          {': '}
          {carrier}
        </li>
      </ul>
      <ul className='pl0-sm pl5-md'>
        <li>
          <TranslatedCopy id='orderstatus.packingListNumber' />
          {': '}
          {billOfLadingNumber}
        </li>
        <li>
          <TranslatedCopy id='global.shipping.method' />
          {': '}
          {shippingMethod}
        </li>
        <li>
          <TranslatedCopy id='orderstatus.shippingOrigin' />
          {': '}
          {shippingOrigin}
        </li>
      </ul>
    </div>
  </div>
);

OrderDetailsShipmentEventInfo.propTypes = {
  shipmentNumber: PropTypes.number.isRequired,
  shipmentsTotal: PropTypes.number.isRequired,
  cartonsTotal: PropTypes.number.isRequired,
  carrierUrlAddress: PropTypes.string,
  trackingNumber: PropTypes.string.isRequired,
  dateShipped: PropTypes.string.isRequired,
  estimatedDeliveryDate: PropTypes.string.isRequired,
  carrier: PropTypes.string.isRequired,
  shippingMethod: PropTypes.string.isRequired,
  shippingOrigin: PropTypes.string.isRequired,
  billOfLadingNumber: PropTypes.string.isRequired
};

OrderDetailsShipmentEventInfo.defaultProps = {
  carrierUrlAddress: ''
};

export default OrderDetailsShipmentEventInfo;
